AFRAME.registerPrimitive('a-tour', {
  defaultComponents: {
    tour: {}
  }
});

AFRAME.registerComponent('tour', {
  init: function () {
    var self = this;

    this.zoom = 1.0;
    this.wheelIncrement = 0.0125;
    this.wheel = 0.0;

    window.addEventListener('resize', this.onResize.bind(this));
    window.addEventListener('load', this.onLoad.bind(this));
    window.addEventListener('wheel', this.handleWheel.bind(this));
  },

  loadSceneId: function(id) {
    if (id == 'main')  {
      this.setLanguage();
      this.checkScreen();
      this.load2dImage(this.el.querySelector('a-panorama#' + id));
    } else {
      this.onlineLoadVideo(this.el.querySelector('a-panorama#' + id));
    }
    this.setHotspots(id);
  },

  setLanguage(){
    var search = window.location.search;
    if (search === "?lang=en")
      this.language = "en";

    // Credits
    var div = document.getElementById("credit");
    if (this.language === "en") {
      div.innerHTML =
      'This experience is built by <a href="https://www.imersys.com/en">Imersys</a>';
    } else {
      div.innerHTML =
      'Esta experiência é desenvolvida por <a href="https://www.imersys.com/">Imersys</a>';
    }
    document.body.appendChild(div);

    // Hamburguer menu
    if (this.language === "en") {
      document.getElementById("el-noite").textContent = 'Night life';
      document.getElementById("el-compras").textContent = 'Shopping';
      document.getElementById("el-gastro").textContent = 'Food';
      document.getElementById("el-hotel").textContent = 'Hotel';
      document.getElementById("el-eventos").textContent = 'Events';
    }

    if (this.language === "en") {
      var prefix = "images/EN_";
    } else
      var prefix = "images/";

    // HUD
    var huds = Array.prototype.slice.call(this.el.querySelectorAll('a-panorama'));
    huds.forEach(function (h) {
      if (h.hasAttribute('srcDesc')) {
        newh = prefix + h.getAttribute('srcDesc');
        h.setAttribute('srcDesc', newh);
      }
    })

    // Main map
    var main = document.getElementById("main");
    newm = prefix + main.getAttribute('src');
    console.log("print: " + newm);
    main.setAttribute('src', newm);
  },

  checkScreen(){
    var w = window,
    d = document,
    e = d.documentElement,
    g = d.getElementsByTagName('body')[0],
    x = w.innerWidth || e.clientWidth || g.clientWidth,
    y = w.innerHeight|| e.clientHeight|| g.clientHeight;

    if (x <= 900) {
      var preloader = document.getElementById('preloader');
      preloader.style.display = "none";

      var small = document.getElementById('smallscreen');
      small.style.display = "block";

      console.log("This site doesn't support small screens: " + x);
      throw new Error("EarlyExit");
    }
  },

  load2dImage: function (image) {
    var preloader = document.getElementById('preloader');
    preloader.style.display = "block";

    var plane = this.plane;

    plane.setAttribute('visible', 'true');
    plane.setAttribute('src', image.getAttribute('src'));
    plane.addEventListener("loaded", ImageLoaded, false);
    function ImageLoaded(event) {
      var plane = document.getElementById('mainplane');
      plane.removeEventListener("loaded", ImageLoaded, false);

      var preloader = document.getElementById('preloader');
      preloader.style.display = "none";

      var hamburger = document.getElementById('button-menu');
      hamburger.style.display = "block";

      var logo = document.getElementById('logo');
      logo.style.display = "block";
    }

    plane.setAttribute('position', '0 -0.9 -4');
    plane.setAttribute('scale', '11 11 11');

    var camera = this.el.sceneEl.camera.el;
    camera.setAttribute('rotation', image.getAttribute('rotation'));
    camera.setAttribute('look-controls', 'enabled', false);
  },

  onlineLoadVideo: function (image) {
    var preloader = document.getElementById('preloader');
    preloader.style.display = "block";

    var logo = document.getElementById('logo');
    logo.style.display = "none";

    var hamburger = document.getElementById('button-menu');
    hamburger.style.display = "none";

    id = image.getAttribute("srcId");
    console.log('onlineLoadVideo ' + id);
    hamburger.VideoId = id;
    self.VideoId = id;

    // Lazy-load iframe
    var el = document.getElementById(id);
    if (el.getAttribute('src') == "")
      el.setAttribute('src', el.getAttribute('data-src'));

    var player = new Vimeo.Player(id);
    player.ready().then(function() {
      console.log('player: ready');
      var preloader = document.getElementById('preloader');
      preloader.style.display = "none";

      var plane = document.getElementById('mainplane');
      plane.setAttribute('visible', 'false');

      player.play();
    });
    
    player.on('play', function() {
      var close = document.getElementById('button-close');
      close.style.display = "block";

      console.log('player: play ' + self.VideoId);
      var elId = document.getElementById(self.VideoId);

      elId.style.display = "block";
      elId.style.zIndex = 1;
    });

    player.addCuePoint(1, {
      customKey: 'customValue'
    }).then(function(cueId) {
      console.log('player: AddCuepoint: ' + cueId);
      hamburger.cueId = cueId;
    });

    player.on('loaded', function() {
      console.log('player: loaded ' + self.VideoId);
    });

    player.on('cuepoint', function() {
      console.log('cuepoint');
      var hud = document.getElementById('hud');
      hud.addEventListener("load", resultImageLoaded, false);

      function resultImageLoaded(event) {
        console.log('hud: on load');
        var hud = document.getElementById('hud');
        hud.removeEventListener("load", resultImageLoaded, false);

        hud.style.display = "block";
        timeout = setTimeout(function() {
          console.log('timeout-ed');
          var hud = document.getElementById('hud');
          hud.style.display = "none";
        }, 5000);
        hud.setAttribute('timeout', timeout);
      }

      hud.setAttribute('src', image.getAttribute('srcDesc'));
    });

    this.tour = document.querySelector('a-tour');
    var tour = this.tour.components['tour'];
    tour.setHotspots('unknown-whateverid');
  },

  setHotspots: function(id) {
    var hotspots = Array.prototype.slice.call(this.el.querySelectorAll('a-hotspot'));
    hotspots.forEach(function (spot) {
      var visible = spot.getAttribute('for') == id ? true : false;
      spot.setAttribute('visible', visible);
    })
  },

  handleWheel: function (e) {
    var camera = this.el.sceneEl.camera.el;
    var inc;

    if (e.deltaY < 0) {
      inc = e.deltaY <= -100 ? this.wheelIncrement * 4 : this.wheelIncrement;
    } else {
      inc = e.deltaY >= 100 ? this.wheelIncrement * -4 : -this.wheelIncrement;
    }

    this.wheel = this.wheel + inc;

    if (this.wheel < -0.30)
       this.wheel = -0.30;
    else if (this.wheel > 0.30)
      this.wheel = 0.30;

    camera.setAttribute('camera', 'zoom', (this.zoom + this.wheel));
    //console.log("camera zoom: " + (this.zoom + this.wheel));
  },

  onResize: function (e) {
    this.handleResize();
  },

  onLoad: function (e) {
    this.plane = document.createElement('a-plane');
    this.el.appendChild(this.plane);
    this.plane.setAttribute('id', 'mainplane');

    var images = Array.prototype.slice.call(this.el.querySelectorAll('a-panorama'));
    if (images.length === 0) {
      console.error('You need to specify at least 1 image!');
      return;
    }
    var start = images[0];
    this.loadSceneId(start.getAttribute('id'));

    this.handleResize();
  },

  handleResize: function () {
    var camera = this.el.sceneEl.camera.el;

    //console.log("resize: " + window.innerWidth + " " + window.innerHeight);
    if ((window.innerWidth < 400))
        this.zoom = 0.34;
    else if ((window.innerWidth >= 400 && window.innerWidth <= 500))
        this.zoom = 0.40;
    else if ((window.innerWidth > 500 && window.innerWidth <= 600))
        this.zoom = 0.46;
    else if ((window.innerWidth > 600 && window.innerWidth <= 700))
        this.zoom = 0.54;
    else if ((window.innerWidth > 700 && window.innerWidth <= 800))
        this.zoom = 0.60;
    else if ((window.innerWidth > 800 && window.innerWidth <= 900))
        this.zoom = 0.68;
    else if ((window.innerWidth > 900 && window.innerWidth <= 1000))
        this.zoom = 0.75;
    else if ((window.innerWidth > 1000 && window.innerWidth <= 1100))
        this.zoom = 0.85;
    else if ((window.innerWidth > 1100 && window.innerWidth <= 1200))
        this.zoom = 0.92;
    else if ((window.innerWidth > 1200 && window.innerWidth <= 1300))
        this.zoom = 1.01;
    else if ((window.innerWidth > 1300 && window.innerWidth <= 1400))
        this.zoom = 1.09;
    else if ((window.innerWidth > 1400 && window.innerWidth <= 1500))
        this.zoom = 1.20;
    else if ((window.innerWidth > 1500))// && window.innerWidth <= 1600))
        this.zoom = 1.25;

    camera.setAttribute('camera', 'zoom', (this.zoom + this.wheel));
    //console.log("camera zoom: " + (this.zoom + this.wheel));
  }
});
